import axios from 'axios';
import { useStorage } from '../hooks/use-storage';

function useConfigAPI() {
  const { languageRef } = useStorage();

  function loadConfigFromRemote() {
    const url = `/vbeta2/platform/config`;

    return axios({
      url,
      method: 'get',
      responseType: 'json',
      params: {
        lang: languageRef.current?.tag,
      },
      headers: {
        'Accept-Language': languageRef.current?.tag,
      },
    });
  }

  return {
    loadConfigFromRemote,
  };
}

export { useConfigAPI };
